<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Markvision Enterprise">
     Markvision Enterprise
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history.html#change-history_it" title="Cronologia delle modifiche">
     Cronologia delle modifiche
    </a>
   </p>
   <div id="divd0e8">
   </div>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter_it" title="Panoramica">
     Panoramica
    </a>
   </p>
   <div id="divd0e260">
    <p class="toc-2-style">
     <a href="overview-chapter.html#overview-markvision-enterprise_it" title="Informazioni su Markvision Enterprise">
      Informazioni su Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="getting-started-chapter.html#getting-started-chapter_it" title="Introduzione">
     Introduzione
    </a>
   </p>
   <div id="divd0e289">
    <p class="toc-2-style">
     <a href="best-practices-topic.html#best-practices_it" title="Best practice">
      Best practice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="system-requirements-topic.html#system-requirements_it" title="Requisiti di sistema">
      Requisiti di sistema
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-languages-topic.html#supported-languages_it" title="Lingue supportate">
      Lingue supportate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-printer-models-topic.html#supported-printer-models_it" title="Modelli di stampante supportati">
      Modelli di stampante supportati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-database-topic.html#setting-up-database_it" title="Configurazione del database">
      Configurazione del database
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-mve-run-as-user-topic.html#d0e1132" title="Impostazione di Esegui come utente">
      Impostazione di Esegui come utente
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-markvision-topic.html#installing-markvision_it" title="Installazione di MVE">
      Installazione di MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-mve-silently-topic.html#installing-mve-silently_it" title="Installazione di MVE invisibile all'utente">
      Installazione di MVE invisibile all'utente
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-topic.html#accessing-mve_it" title="Accesso a MVE">
      Accesso a MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-topic.html#changing-language_it" title="Modifica della lingua">
      Modifica della lingua
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-your-password-topic.html#changing-your-password_it" title="Modifica della password">
      Modifica della password
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-application-chapter.html#maintaining-application-chapter_it" title="Manutenzione dell'applicazione">
     Manutenzione dell'applicazione
    </a>
   </p>
   <div id="divd0e1715">
    <p class="toc-2-style">
     <a href="upgrading-to-latest-version-topic.html#upgrading-to-latest-version_it" title="Aggiornamento a MVE 4.3">
      Aggiornamento a MVE 4.3
     </a>
    </p>
    <p class="toc-2-style">
     <a href="backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_it" title="Backup e ripristino del database">
      Backup e ripristino del database
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-installer-settings-topic.html#changing-installer-settings_it" title="Aggiornamento delle impostazioni del programma di installazione dopo l'installazione">
      Aggiornamento delle impostazioni del programma di installazione dopo l'installazione
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-user-access-chapter.html#setting-user-access-chapter_it" title="Configurazione dell'accesso utente">
     Configurazione dell'accesso utente
    </a>
   </p>
   <div id="divd0e1987">
    <p class="toc-2-style">
     <a href="setting-up-user-access-overview-topic.html#setting-up-user-access-overview_it" title="Panoramica">
      Panoramica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-user-roles-topic.html#understanding-user-roles_it" title="Informazioni sui ruoli utente">
      Informazioni sui ruoli utente
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-users-topic.html#managing-users_it" title="Gestione degli utenti">
      Gestione degli utenti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_it" title="Abilitazione dell'autenticazione tramite server LDAP">
      Abilitazione dell'autenticazione tramite server LDAP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_it" title="Installazione dei certificati del server LDAP">
      Installazione dei certificati del server LDAP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-root-ca-certificate-java-truststore-topic.html#adding-root-ca-certificate-java-truststore_it" title="Aggiunta di un certificato CA radice al truststore Java">
      Aggiunta di un certificato CA radice al truststore Java
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="discovering-devices-chapter.html#discovering-devices-chapter_it" title="Rilevamento delle stampanti">
     Rilevamento delle stampanti
    </a>
   </p>
   <div id="divd0e2401">
    <p class="toc-2-style">
     <a href="creating-discovery-profile-topic.html#creating-discovery-profile_it" title="Creazione di un profilo di ricerca">
      Creazione di un profilo di ricerca
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-discovery-profiles-topic.html#managing-discovery-profiles_it" title="Gestione dei profili di ricerca">
      Gestione dei profili di ricerca
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_it" title="Scenario di esempio: rilevamento delle stampanti">
      Scenario di esempio: rilevamento delle stampanti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_it" title="Gestione della dashboard di protezione">
     Gestione della dashboard di protezione
    </a>
   </p>
   <div id="divd0e2657">
    <p class="toc-2-style">
     <a href="overview-security-dashboard-topic.html#overview-security-dashboard_it" title="Panoramica">
      Panoramica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-dashboard-topic.html#accessing-dashboard_it" title="Accesso al dashboard di protezione">
      Accesso al dashboard di protezione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-security-information-topic.html#managing-device-security-information_it" title="Gestione di Informazioni sulla protezione della periferica">
      Gestione di Informazioni sulla protezione della periferica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-conformance-check-topic.html#managing-device-conformance-check_it" title="Gestione di Controllo conformit&agrave; periferica">
      Gestione di Controllo conformit&agrave; periferica
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="finding-devices-chapter.html#finding-devices-chapter_it" title="Visualizzazione delle stampanti">
     Visualizzazione delle stampanti
    </a>
   </p>
   <div id="divd0e2766">
    <p class="toc-2-style">
     <a href="viewing-printer-list-topic.html#viewing-printer-list_it" title="Visualizzazione dell'elenco stampanti">
      Visualizzazione dell'elenco stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-device-information-topic.html#viewing-device-information_it" title="Visualizzazione delle informazioni della stampante">
      Visualizzazione delle informazioni della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-data-topic.html#exporting-data_it" title="Esportazione dei dati della stampante">
      Esportazione dei dati della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-views-topic.html#managing-views_it" title="Gestione delle visualizzazioni">
      Gestione delle visualizzazioni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-printer-listing-view-topic.html#changing-printer-listing-view_it" title="Modifica della visualizzazione dell'elenco stampanti">
      Modifica della visualizzazione dell'elenco stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_it" title="Filtraggio delle stampanti dalla barra di ricerca">
      Filtraggio delle stampanti dalla barra di ricerca
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-keywords-topic.html#managing-keywords_it" title="Gestione delle parole chiave">
      Gestione delle parole chiave
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-device-life-cycle-states-topic.html#d0e3226" title="Uso delle ricerche salvate">
      Uso delle ricerche salvate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_it" title="Scenario di esempio: monitoraggio dei livelli di toner del parco stampanti">
      Scenario di esempio: monitoraggio dei livelli di toner del parco stampanti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-devices-chapter.html#securing-devices-chapter_it" title="Protezione delle comunicazioni della stampante">
     Protezione delle comunicazioni della stampante
    </a>
   </p>
   <div id="divd0e4163">
    <p class="toc-2-style">
     <a href="understanding-security-status-topic.html#understanding-security-status_it" title="Informazioni sugli stati di protezione della stampante">
      Informazioni sugli stati di protezione della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-using-default-config-topic.html#securing-printers-using-default-config_it" title="Protezione delle stampanti mediante le configurazioni predefinite">
      Protezione delle stampanti mediante le configurazioni predefinite
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-fac-permissions-topic.html#understanding-fac-permissions_it" title="Informazioni sulle autorizzazioni e i controlli di accesso alle funzioni">
      Informazioni sulle autorizzazioni e i controlli di accesso alle funzioni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-device-security-topic.html#configuring-device-security_it" title="Configurazione della protezione della stampante">
      Configurazione della protezione della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_it" title="Protezione delle comunicazioni della stampante nel parco stampanti">
      Protezione delle comunicazioni della stampante nel parco stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-topic.html#securing-printers_it" title="Altri modi per proteggere le stampanti">
      Altri modi per proteggere le stampanti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-assets-chapter.html#managing-assets-chapter_it" title="Gestione delle stampanti">
     Gestione delle stampanti
    </a>
   </p>
   <div id="divd0e4527">
    <p class="toc-2-style">
     <a href="restarting-printer-topic.html#restarting-printer_it" title="Riavvio della stampante">
      Riavvio della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-ews-topic.html#viewing-ews_it" title="Visualizzazione di Embedded Web Server della stampante">
      Visualizzazione di Embedded Web Server della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="auditing-devices-topic.html#auditing-devices_it" title="Controllo delle stampanti">
      Controllo delle stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-status-topic.html#updating-printer-status_it" title="Aggiornamento dello stato della stampante">
      Aggiornamento dello stato della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-device-state-topic.html#setting-device-state_it" title="Impostazione dello stato della stampante">
      Impostazione dello stato della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_it" title="Assegnazione di configurazioni alle stampanti">
      Assegnazione di configurazioni alle stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unassigning-configurations-topic.html#unassigning-configurations_it" title="Annullamento dell'assegnazione delle configurazioni">
      Annullamento dell'assegnazione delle configurazioni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enforcing-configurations-topic.html#enforcing-configurations_it" title="Applicazione delle configurazioni">
      Applicazione delle configurazioni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-device-conformance-topic.html#checking-device-conformance_it" title="Controllo della conformit&agrave; di una stampante con una configurazione">
      Controllo della conformit&agrave; di una stampante con una configurazione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="deploying-files-to-printers-topic.html#deploying-files-to-printers_it" title="Distribuzione dei file alle stampanti">
      Distribuzione dei file alle stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-firmware-topic.html#updating-printer-firmware_it" title="Aggiornamento del firmware delle stampanti">
      Aggiornamento del firmware delle stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_it" title="Disinstallazione delle applicazioni dalle stampanti">
      Disinstallazione delle applicazioni dalle stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-events-to-device-topic.html#assigning-events-to-device_it" title="Assegnazione di eventi alle stampanti">
      Assegnazione di eventi alle stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-keyword-topic.html#assigning-keyword_it" title="Assegnazione di parole chiave alle stampanti">
      Assegnazione di parole chiave alle stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_it" title="Immissione delle credenziali per le stampanti protette">
      Immissione delle credenziali per le stampanti protette
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_it" title="Configurazione manuale dei certificati predefiniti delle stampanti">
      Configurazione manuale dei certificati predefiniti delle stampanti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-printers-topic.html#removing-printers_it" title="Rimozione di stampanti">
      Rimozione di stampanti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-configurations-chapter.html#managing-configurations-chapter_it" title="Gestione delle configurazioni">
     Gestione delle configurazioni
    </a>
   </p>
   <div id="divd0e5133">
    <p class="toc-2-style">
     <a href="managing-configurations-overview-topic.html#managing-configurations-overview_it" title="Panoramica">
      Panoramica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-topic.html#creating-configuration_it" title="Creazione di una configurazione">
      Creazione di una configurazione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-from-printer-topic.html#creating-configuration-from-printer_it" title="Creazione di una configurazione da una stampante">
      Creazione di una configurazione da una stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_it" title="Scenario di esempio: clonazione di una configurazione">
      Scenario di esempio: clonazione di una configurazione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-advanced-security-component-topic.html#creating-advanced-security-component_it" title="Creazione di un componente di protezione avanzata da una stampante">
      Creazione di un componente di protezione avanzata da una stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-printable-version-topic.html#generating-printable-version_it" title="Generazione di una versione stampabile delle impostazioni di configurazione">
      Generazione di una versione stampabile delle impostazioni di configurazione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-dynamic-settings-topic.html#understanding-dynamic-settings_it" title="Informazioni sulle impostazioni dinamiche">
      Informazioni sulle impostazioni dinamiche
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-variable-settings-topic.html#understanding-variable-settings_it" title="Informazioni sulle impostazioni delle variabili">
      Informazioni sulle impostazioni delle variabili
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-color-permissions-topic.html#configuring-color-permissions_it" title="Configurazione delle autorizzazioni per la stampa a colori">
      Configurazione delle autorizzazioni per la stampa a colori
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-applications-package-topic.html#creating-applications-package_it" title="Creazione di un pacchetto di applicazioni">
      Creazione di un pacchetto di applicazioni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_it" title="Importazione o esportazione di una configurazione">
      Importazione o esportazione di una configurazione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-files-to-resource-library-topic.html#importing-files-to-resource-library_it" title="Importazione di file nella libreria delle risorse">
      Importazione di file nella libreria delle risorse
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_it" title="Gestione dei certificati">
     Gestione dei certificati
    </a>
   </p>
   <div id="divd0e5644">
    <p class="toc-2-style">
     <a href="setting-up-MVE-manage-certificates-automatically-group.html#d0e5647" title="Configurazione di MVE per la gestione automatica dei certificati">
      Configurazione di MVE per la gestione automatica dei certificati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-SCEP-group.html#d0e5973" title="Gestione dei certificati con l'autorit&agrave; di certificazione Microsoft tramite SCEP">
      Gestione dei certificati con l'autorit&agrave; di certificazione Microsoft tramite SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-MSCEWS-group.html#d0e6695" title="Gestione dei certificati con l'autorit&agrave; di certificazione Microsoft tramite MSCEWS">
      Gestione dei certificati con l'autorit&agrave; di certificazione Microsoft tramite MSCEWS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-OpenXPKI-CA-group.html#d0e7680" title="Gestione dei certificati con l'autorit&agrave; di certificazione OpenXPKI tramite SCEP">
      Gestione dei certificati con l'autorit&agrave; di certificazione OpenXPKI tramite SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-EST-group.html#d0e8747" title="Gestione dei certificati con l'autorit&agrave; di certificazione OpenXPKI tramite EST">
      Gestione dei certificati con l'autorit&agrave; di certificazione OpenXPKI tramite EST
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-device-alerts-chapter.html#managing-device-alerts-chapter_it" title="Gestione degli avvisi della stampante">
     Gestione degli avvisi della stampante
    </a>
   </p>
   <div id="divd0e9832">
    <p class="toc-2-style">
     <a href="managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_it" title="Panoramica">
      Panoramica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-action-topic.html#creating-action_it" title="Creazione di un'azione">
      Creazione di un'azione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-action-placeholders-topic.html#understanding-action-placeholders_it" title="Comprensione segnaposto azione">
      Comprensione segnaposto azione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-actions-topic.html#managing-actions_it" title="Gestione delle azioni">
      Gestione delle azioni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-event-topic.html#creating-event_it" title="Creazione di un evento">
      Creazione di un evento
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-printer-alerts-topic.html#understanding-printer-alerts_it" title="Informazioni sugli avvisi della stampante">
      Informazioni sugli avvisi della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-events-topic.html#managing-events_it" title="Gestione degli eventi">
      Gestione degli eventi
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="viewing-tasks-chapter.html#viewing-tasks-chapter_it" title="Visualizzazione della cronologia e dello stato delle attivit&agrave;">
     Visualizzazione della cronologia e dello stato delle attivit&agrave;
    </a>
   </p>
   <div id="divd0e10464">
    <p class="toc-2-style">
     <a href="viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_it" title="Panoramica">
      Panoramica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-task-status-topic.html#viewing-task-status_it" title="Visualizzazione dello stato delle attivit&agrave;">
      Visualizzazione dello stato delle attivit&agrave;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stopping-tasks-topic.html#stopping-tasks_it" title="Interruzione delle attivit&agrave;">
      Interruzione delle attivit&agrave;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-logs-topic.html#viewing-logs_it" title="visualizzazione dei registri">
      visualizzazione dei registri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-logs-topic.html#clearing-logs_it" title="Eliminazione dei registri">
      Eliminazione dei registri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-logs-topic.html#exporting-logs_it" title="Esportazione dei registri">
      Esportazione dei registri
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="scheduling-tasks.html#scheduling-tasks_it" title="Programmazione delle attivit&agrave;">
     Programmazione delle attivit&agrave;
    </a>
   </p>
   <div id="divd0e10572">
    <p class="toc-2-style">
     <a href="creating-schedule-topic.html#creating-schedule_it" title="Creazione di un programma">
      Creazione di un programma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-schedules-topic.html#managing-schedules_it" title="Gestione delle attivit&agrave; programmate">
      Gestione delle attivit&agrave; programmate
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="admin-tasks-chapter.html#admin-tasks-chapter_it" title="Esecuzione di altre attivit&agrave; amministrative">
     Esecuzione di altre attivit&agrave; amministrative
    </a>
   </p>
   <div id="divd0e10714">
    <p class="toc-2-style">
     <a href="configuring-system-settings-topic.html#configuring-system-settings_it" title="Configurazione delle impostazioni generali">
      Configurazione delle impostazioni generali
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-email-settings-topic.html#configuring-email-settings_it" title="Configurazione delle impostazioni e-mail">
      Configurazione delle impostazioni e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-login-disclaimer-topic.html#adding-login-disclaimer_it" title="Aggiunta di una declinazione di responsabilit&agrave; prima dell'accesso">
      Aggiunta di una declinazione di responsabilit&agrave; prima dell'accesso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="signing-mve-certificate-topic.html#signing-mve-certificate_it" title="Firma del certificato MVE">
      Firma del certificato MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-user-information-topic.html#removing-user-information_it" title="Rimozione di informazioni e riferimenti dell'utente">
      Rimozione di informazioni e riferimenti dell'utente
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-SSO-chapter.html#managing-SSO-chapter_it" title="Gestione SSO">
     Gestione SSO
    </a>
   </p>
   <div id="divd0e10972">
    <p class="toc-2-style">
     <a href="mve-configuration-workflow-adfs-overview-topic.html#d0e10977" title="Panoramica">
      Panoramica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-claim-issuance-policy-grouprule-topic.html#setting-claim-issuance-policy-grouprule_it" title="Impostazione dei criteri di rilascio delle attestazioni per GroupRule">
      Impostazione dei criteri di rilascio delle attestazioni per GroupRule
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-claim-issuance-policy-name-id-topic.html#setting-claim-issuance-policy-name-id_it" title="Impostazione dei criteri di rilascio delle attestazioni per ID nome">
      Impostazione dei criteri di rilascio delle attestazioni per ID nome
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-adfs-server-authentication-topic.html#enabling-adfs-server-authentication_it" title="Abilitazione dell'autenticazione tramite server ADFS">
      Abilitazione dell'autenticazione tramite server ADFS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-adfs-topic.html#accessing-mve-adfs_it" title="Accesso a MVE tramite ADFS">
      Accesso a MVE tramite ADFS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="logging-out-mve-adfs-topic.html#logging-out-mve-adfs_it" title="Disconnessione da MVE">
      Disconnessione da MVE
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faq-chapter.html#faq-chapter_it" title="Domande frequenti">
     Domande frequenti
    </a>
   </p>
   <div id="divd0e11142">
    <p class="toc-2-style">
     <a href="faq-chapter.html#frequently-asked-questions_it" title="Domande frequenti su Markvision Enterprise">
      Domande frequenti su Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_it" title="Risoluzione dei problemi">
     Risoluzione dei problemi
    </a>
   </p>
   <div id="divd0e11336">
    <p class="toc-2-style">
     <a href="trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_it" title="L'utente ha dimenticato la password">
      L'utente ha dimenticato la password
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_it" title="L'utente amministratore ha dimenticato la password">
      L'utente amministratore ha dimenticato la password
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_it" title="La pagina non viene caricata">
      La pagina non viene caricata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_it" title="Impossibile rilevare una stampante di rete">
      Impossibile rilevare una stampante di rete
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-incorrect-device-information-topic.html#trb-incorrect-device-information_it" title="Informazioni stampante errate">
      Informazioni stampante errate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_it" title="MVE non riconosce una stampante come stampante protetta">
      MVE non riconosce una stampante come stampante protetta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_it" title="L'applicazione di configurazioni con pi&ugrave; applicazioni non riesce al primo tentativo ma riesce con i tentativi successivi">
      L'applicazione di configurazioni con pi&ugrave; applicazioni non riesce al primo tentativo ma riesce con i tentativi successivi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_it" title="L'applicazione di configurazioni con il certificato della stampante non riesce">
      L'applicazione di configurazioni con il certificato della stampante non riesce
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-openxpki-ca-group.html#d0e11553" title="Autorit&agrave; di certificazione OpenXPKI">
      Autorit&agrave; di certificazione OpenXPKI
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="database-access-chapter.html#database-access-chapter_it" title="Accesso al database">
     Accesso al database
    </a>
   </p>
   <div id="divd0e11723">
    <p class="toc-2-style">
     <a href="differences-supported-databases-data-types-topic.html#differences-supported-databases-data-types_it" title="Differenze tra i tipi di dati dei database supportati">
      Differenze tra i tipi di dati dei database supportati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="config-item-topic.html#d0e11784" title="Tabelle di FRAMEWORK e nomi dei campi">
      Tabelle di FRAMEWORK e nomi dei campi
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="appendix-chapter.html#appendix-chapter_it" title="Appendice">
     Appendice
    </a>
   </p>
   <div id="divd0e17724">
    <p class="toc-2-style">
     <a href="understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_it" title="Informazioni su porte e protocolli">
      Informazioni su porte e protocolli
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_it" title="Abilitazione dell'approvazione automatica delle richieste di certificato in CA Microsoft">
      Abilitazione dell'approvazione automatica delle richieste di certificato in CA Microsoft
     </a>
    </p>
    <p class="toc-2-style">
     <a href="revoking-certificates-topic.html#revoking-certificates_it" title="Revoca di certificati">
      Revoca di certificati
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices_it" title="Avvertenze">
     Avvertenze
    </a>
   </p>
   <div id="divd0e18100">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e18103" title="Nota sull'edizione">
      Nota sull'edizione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e18139" title="Marchi">
      Marchi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#us-government-rights_it" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#jmdns-license_it" title="JmDNS License">
      JmDNS License
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#licensing-notices-program-folder_it" title="Informazioni sulla licenza">
      Informazioni sulla licenza
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="glossary.html#glossary_it" title="Glossario">
     Glossario
    </a>
   </p>
   <div id="divd0e18169">
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue